var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleGreenBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 10,
    fill: "#00535C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7295 7.96753C12.9987 7.69832 13.4351 7.69832 13.7043 7.96753C13.9736 8.23673 13.9736 8.6732 13.7043 8.9424L9.56832 13.0784C9.29911 13.3476 8.86265 13.3476 8.59345 13.0784L6.29565 10.7806C6.02645 10.5114 6.02645 10.075 6.29565 9.80576C6.56486 9.53656 7.00132 9.53656 7.27052 9.80576L9.08088 11.6161L12.7295 7.96753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreenBg);
export default __webpack_public_path__ + "static/media/check-circle-green-bg.21fa97a5.svg";
export { ForwardRef as ReactComponent };